export const aboutUsConfig = {
  id: 1,
  apropos: '关于',
  my: '我们',
  aproposMy: 'ABOUT US',
  word: [
    '天津挚云数字科技有限公司（简称：挚云数科）于2020年4月成立，注册资本金1000万元，是行业领先的供应链金融科技解决方案提供商，天津市商业保理协会副会长单位。',
    '挚云数科坚持科技 + 运营的理念，专注于为保理公司提供专业、高效的供应链金融科技系统与运营服务，服务包括实体企业、第三方机构及金融机构在内的参与各方，致力于构建覆盖供应链金融全流程的生态系统。',
    '挚云数科具备行业领先的供应链金融科技研发实力与运营能力，基于保理公司、大型央企、国企以及A股上市公司等优质企业客户的供应链正、反向保理融资项目实际需求，针对业务痛点、难点，依托私有云、AI、区块链、大数据等技术手段，提供专业的服务。',
  ],
};

export const DevelopmentExperienceList = [
  {
    num: 1,
    year: '2019年',
    text: [
      '习近平总书记在中共中央政治局第十三次集体学习时提出,加快金融服务供给侧改革。社会各界积极响应号召,顺应数字化发展浪潮；',
    ],
  },
  {
    num: 2,
    year: '2020年',
    text: [
      '挚云数科正式成立；',
      '同年，开始研发供应链金融系统，为中小型企业提供融资服务；',
    ],
  },
  {
    num: 3,
    year: '2021年',
    text: [
      '供应链金融系统V1.0研发上线;',
      '荣获"天津保理协会副会长单位";',
      '申请3个专利;',
    ],
  },
  {
    num: 4,
    year: '2022年',
    text: [
      '供应链金融系统V2.0研发上线;',
      '保理系统V1.0上线;',
      '获得国家高新技术企业;',
    ],
  },
  {
    num: 5,
    year: '2023年',
    text: [
      '供应链金融持续选代开发系统;',
      '保理系统V2.0上线;',
      "荣获'天津市软件行业协会会员单位';",
      '成为天津移动生态合作伙伴;',
      `荣获'海纳联盟ISV同盟会会员';`,
      '天津市科技型中小企业;',
      '新增30+软件著作权;',
    ],
  },
];
